/* eslint-disable @typescript-eslint/no-unused-vars */
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getFirestore,
  collection,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD0ZiI1artAV3bEBGCTdfkWVTjOKBHDR0Y",
  authDomain: "microlearning-app-5cb60.firebaseapp.com",
  projectId: "microlearning-app-5cb60",
  storageBucket: "microlearning-app-5cb60.firebasestorage.app",
  messagingSenderId: "891287550887",
  appId: "1:891287550887:web:b3c531234ccda4d3451482",
  measurementId: "G-F1C06PNQ6F",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

// Collection reference for delete account requests
const deleteAccountCollection = collection(db, "deleteAccount");

// Function to submit delete account request
export const submitDeleteAccountRequest = async (
  email: string,
  reason: string
) => {
  try {
    const docRef = await addDoc(deleteAccountCollection, {
      email,
      reason,
      createdAt: serverTimestamp(),
      status: "pending",
    });

    return { success: true, id: docRef.id };
  } catch (error) {
    console.error("Error submitting delete account request:", error);
    return { success: false, error };
  }
};
